/* eslint-disable */
import GraphQL from '../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSendingOfAlertsAndReportsFromWebsiteMutationVariables = GraphQL.Exact<{
  invitations: ReadonlyArray<GraphQL.UpdateSendingOfAlertsAndReportsFromWebsiteInvitation> | GraphQL.UpdateSendingOfAlertsAndReportsFromWebsiteInvitation;
  users: ReadonlyArray<GraphQL.UpdateSendingOfAlertsAndReportsFromWebsiteUser> | GraphQL.UpdateSendingOfAlertsAndReportsFromWebsiteUser;
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UpdateSendingOfAlertsAndReportsFromWebsiteMutation = { readonly __typename?: 'Mutation', readonly UpdateSendingOfAlertsAndReportsFromWebsite: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly displayName: string, readonly email: string, readonly hasLimitedWebsitesAccess: boolean, readonly id: CK.InvitationId, readonly role: GraphQL.UserRole, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly hasLimitedWebsitesAccess: boolean, readonly role: GraphQL.UserRole, readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly displayName: string, readonly email: string, readonly firstName: string | null, readonly hasTwoFactorAuthentication: boolean, readonly id: string, readonly lastName: string | null, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }> }> } | null, readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly alertDefinitions: ReadonlyArray<{ readonly __typename?: 'AlertDefinition', readonly id: CK.AlertDefinitionId, readonly recipients: ReadonlyArray<string> }> } | null } } };


export const UpdateSendingOfAlertsAndReportsFromWebsiteDocument = gql`
    mutation UpdateSendingOfAlertsAndReportsFromWebsite($invitations: [UpdateSendingOfAlertsAndReportsFromWebsiteInvitation!]!, $users: [UpdateSendingOfAlertsAndReportsFromWebsiteUser!]!, $websiteId: WebsiteId!) {
  UpdateSendingOfAlertsAndReportsFromWebsite(
    invitations: $invitations
    users: $users
    websiteId: $websiteId
  ) {
    query {
      authenticatedSession {
        accounts {
          id
          invitations {
            displayName
            email
            hasLimitedWebsitesAccess
            id
            role
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
            websites {
              id
            }
          }
          memberships {
            account {
              id
            }
            hasLimitedWebsitesAccess
            role
            user {
              displayName
              email
              firstName
              hasTwoFactorAuthentication
              id
              lastName
              legacyId
              websiteEmailSettings {
                alertEmailsSetup
                isWeeklyReportEnabled
                websiteId
              }
            }
            websites {
              id
            }
          }
        }
      }
      website(id: $websiteId) {
        alertDefinitions {
          id
          recipients
        }
        id
      }
    }
  }
}
    `;
export type UpdateSendingOfAlertsAndReportsFromWebsiteMutationFn = Apollo.MutationFunction<UpdateSendingOfAlertsAndReportsFromWebsiteMutation, UpdateSendingOfAlertsAndReportsFromWebsiteMutationVariables>;

/**
 * __useUpdateSendingOfAlertsAndReportsFromWebsiteMutation__
 *
 * To run a mutation, you first call `useUpdateSendingOfAlertsAndReportsFromWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSendingOfAlertsAndReportsFromWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSendingOfAlertsAndReportsFromWebsiteMutation, { data, loading, error }] = useUpdateSendingOfAlertsAndReportsFromWebsiteMutation({
 *   variables: {
 *      invitations: // value for 'invitations'
 *      users: // value for 'users'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUpdateSendingOfAlertsAndReportsFromWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSendingOfAlertsAndReportsFromWebsiteMutation, UpdateSendingOfAlertsAndReportsFromWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSendingOfAlertsAndReportsFromWebsiteMutation, UpdateSendingOfAlertsAndReportsFromWebsiteMutationVariables>(UpdateSendingOfAlertsAndReportsFromWebsiteDocument, options);
      }
export type UpdateSendingOfAlertsAndReportsFromWebsiteMutationHookResult = ReturnType<typeof useUpdateSendingOfAlertsAndReportsFromWebsiteMutation>;
export type UpdateSendingOfAlertsAndReportsFromWebsiteMutationResult = Apollo.MutationResult<UpdateSendingOfAlertsAndReportsFromWebsiteMutation>;
export type UpdateSendingOfAlertsAndReportsFromWebsiteMutationOptions = Apollo.BaseMutationOptions<UpdateSendingOfAlertsAndReportsFromWebsiteMutation, UpdateSendingOfAlertsAndReportsFromWebsiteMutationVariables>;